import { Inject, Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { isEmpty } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { IUnitOfMeasure } from '../insecta.models';
import { DictionaryCacheService } from '../dictionary-cache.service';
import { HttpClient } from '@angular/common/http';
import { SETTINGS, Settings } from '../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class UnitOfMeasureAdminService extends InsectaServiceBase {
  constructor(
    private http: HttpClient,
    @Inject(SETTINGS) settings: Settings,
    private dictionaryCache: DictionaryCacheService
  ) {
    super(http, settings);
  }
  public addUnitOfMeasure(unitOfMeasure: IUnitOfMeasure): Observable<string> {
    return this.post<string>(`/admin/unitsofmeasure`, `v1`, {
      name: unitOfMeasure.name,
      conversionFactor: unitOfMeasure.conversionFactor,
      isActive: unitOfMeasure.isActive,
      username: unitOfMeasure.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('volume')));
  }

  public getUnitOfMeasure(id: string): Observable<IUnitOfMeasure> {
    return this.get<IUnitOfMeasure>(`/admin/unitsofmeasure/${id}`, 'v1');
  }

  public getUnitOfMeasures(includeInActive: boolean | null | undefined): Observable<IUnitOfMeasure[]> {
    if (isEmpty(includeInActive)) includeInActive = false;

    return this.get<IUnitOfMeasure[]>(`/admin/unitsofmeasure`, 'v1').pipe(
      map((results) => [...results].filter((x: IUnitOfMeasure) => includeInActive || x.isActive)),
      map((results) =>
        [...results].sort((a: IUnitOfMeasure, b: IUnitOfMeasure) =>
          a.isActive == b.isActive ? (a.name > b.name ? 1 : -1) : a.isActive < b.isActive ? 1 : -1
        )
      )
    );
  }

  public getUnitOfMeasuresAll(): Observable<IUnitOfMeasure[]> {
    return this.getUnitOfMeasures(true);
  }

  public updateUnitOfMeasure(unitOfMeasure: IUnitOfMeasure): Observable<any> {
    return this.put<IUnitOfMeasure>(`/admin/unitsofmeasure/${unitOfMeasure.id}`, `v1`, {
      id: unitOfMeasure.id,
      conversionFactor: unitOfMeasure.conversionFactor,
      isActive: unitOfMeasure.isActive,
      username: unitOfMeasure.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('volume')));
  }
}
